import { useEffect, useMemo, useState } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/redux/store';

const useBackButtonNavigation = (): void => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFirstVisit = useAppSelector((state) => state.user.isFirstVisit);
  const [pagesWithoutBackButton] = useState(['/']);
  const hideButton = useMemo(
    () =>
      pagesWithoutBackButton.some(
        (item) => !!matchPath(item, location.pathname),
      ),
    [location, pagesWithoutBackButton],
  );

  useEffect(() => {
    Telegram.WebApp.BackButton.onClick(() => {
      navigate(-1);
    });
  }, []);

  useEffect(() => {
    if (location.key === 'default' || hideButton || isFirstVisit) {
      Telegram.WebApp.BackButton.hide();
    } else {
      Telegram.WebApp.BackButton.show();
    }
  }, [location.key, hideButton, isFirstVisit]);
};

export { useBackButtonNavigation };
